exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md_events {\n  margin: 20px 0;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n.md_events .mforward-icon {\n  position: relative;\n  top: 3px;\n  margin-right: 4px;\n  background-color: transparent;\n  font-family: \"FuturaBold\", sans-serif;\n  font-size: 20px;\n  letter-spacing: 0.50px;\n  line-height: 16px;\n}\n.md_events .md_title-skewed.md_title-skewed-hover::before {\n  background: #89221f linear-gradient(45deg, #89231f 0%, #571614 100%);\n}\n.md_events .md_title-skewed.md_title-skewed-hover:hover::before {\n  opacity: 1;\n}\n", ""]);

// exports
